// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsManagement_container__OclcC {
  max-width: 1200px;
  margin: 50px auto;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.NewsManagement_header__N\\+ozw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
}

.NewsManagement_header__N\\+ozw h1 {
  text-align: center;
  color: #333333;
  margin: 0;
  font-size: 2.5rem;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.NewsManagement_addButton__Lf0cd {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #007bff;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.NewsManagement_addButton__Lf0cd:hover:not(:disabled) {
  background: #0056b3;
}

.NewsManagement_addButton__Lf0cd:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.NewsManagement_limitWarning__6jKGa {
  background: #fff3cd;
  color: #856404;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #ffeaa7;
  text-align: center;
  font-weight: 500;
}

.NewsManagement_formOverlay__54z3K {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.NewsManagement_formContainer__kl2fs {
  background: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.NewsManagement_formContainer__kl2fs h2 {
  margin: 0 0 20px 0;
  color: #333;
}

.NewsManagement_form__84t8Z {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.NewsManagement_formGroup__YWeso {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.NewsManagement_formGroup__YWeso label {
  font-weight: 500;
  color: #555;
}

.NewsManagement_formGroup__YWeso input,
.NewsManagement_formGroup__YWeso textarea {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.NewsManagement_formGroup__YWeso input:focus,
.NewsManagement_formGroup__YWeso textarea:focus {
  outline: none;
  border-color: #007bff;
}

.NewsManagement_formActions__uuKV2 {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
}

.NewsManagement_saveButton__tQymD {
  background: #28a745;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.NewsManagement_saveButton__tQymD:hover {
  background: #218838;
}

.NewsManagement_cancelButton__YSNbJ {
  background: #6c757d;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.NewsManagement_cancelButton__YSNbJ:hover {
  background: #545b62;
}

.NewsManagement_newsGrid__Wkb5y {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.NewsManagement_newsCard__7g2ry {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  position: relative;
}

.NewsManagement_newsCard__7g2ry:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.NewsManagement_newsImage__u0Ymv {
  height: 200px;
  overflow: hidden;
}

.NewsManagement_newsImage__u0Ymv img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.NewsManagement_newsContent__NIe2E {
  padding: 20px;
}

.NewsManagement_newsContent__NIe2E h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 18px;
  line-height: 1.4;
}

.NewsManagement_newsContent__NIe2E p {
  margin: 0 0 16px 0;
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.NewsManagement_newsMeta__rs2Qy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #888;
}

.NewsManagement_newsActions__FQA9Y {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.3s;
}

.NewsManagement_newsCard__7g2ry:hover .NewsManagement_newsActions__FQA9Y {
  opacity: 1;
}

.NewsManagement_editButton__P8E-D,
.NewsManagement_deleteButton__4B1BQ {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.NewsManagement_editButton__P8E-D:hover {
  background: #007bff;
  color: white;
}

.NewsManagement_deleteButton__4B1BQ:hover {
  background: #dc3545;
  color: white;
}

.NewsManagement_loading__dMhNI {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 18px;
  color: #666;
}

.NewsManagement_emptyState__jdUs9 {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.NewsManagement_emptyState__jdUs9 p {
  margin: 0 0 20px 0;
  font-size: 18px;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .NewsManagement_container__OclcC {
    padding: 15px;
  }

  .NewsManagement_header__N\\+ozw {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .NewsManagement_header__N\\+ozw h1 {
    font-size: 2rem;
  }

  .NewsManagement_newsGrid__Wkb5y {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .NewsManagement_formContainer__kl2fs {
    width: 95%;
    padding: 20px;
  }

  .NewsManagement_formActions__uuKV2 {
    flex-direction: column;
  }
}

/* Стили для загрузки файлов */
.NewsManagement_imageUploadContainer__KoOFg {
  position: relative;
  margin-bottom: 10px;
}

.NewsManagement_fileInput__K1ql9 {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.NewsManagement_fileInputLabel__ozPV1 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  color: #495057;
}

.NewsManagement_fileInputLabel__ozPV1:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.NewsManagement_imagePreview__20PhP {
  margin-top: 10px;
  max-width: 200px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.NewsManagement_imagePreview__20PhP img {
  width: 100%;
  height: auto;
  display: block;
} `, "",{"version":3,"sources":["webpack://./src/components/AdminPage/News/NewsManagement.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".container {\n  max-width: 1200px;\n  margin: 50px auto;\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.header h1 {\n  text-align: center;\n  color: #333333;\n  margin: 0;\n  font-size: 2.5rem;\n  font-weight: bold;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n}\n\n.addButton:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.addButton:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.limitWarning {\n  background: #fff3cd;\n  color: #856404;\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  border: 1px solid #ffeaa7;\n  text-align: center;\n  font-weight: 500;\n}\n\n.formOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.formContainer {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.formContainer h2 {\n  margin: 0 0 20px 0;\n  color: #333;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.formGroup label {\n  font-weight: 500;\n  color: #555;\n}\n\n.formGroup input,\n.formGroup textarea {\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.3s;\n}\n\n.formGroup input:focus,\n.formGroup textarea:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.formActions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.saveButton {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.saveButton:hover {\n  background: #218838;\n}\n\n.cancelButton {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.cancelButton:hover {\n  background: #545b62;\n}\n\n.newsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.newsCard {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  transition: transform 0.3s, box-shadow 0.3s;\n  position: relative;\n}\n\n.newsCard:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\n.newsImage {\n  height: 200px;\n  overflow: hidden;\n}\n\n.newsImage img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.newsContent {\n  padding: 20px;\n}\n\n.newsContent h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 18px;\n  line-height: 1.4;\n}\n\n.newsContent p {\n  margin: 0 0 16px 0;\n  color: #666;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.newsMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  color: #888;\n}\n\n.newsActions {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  gap: 8px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.newsCard:hover .newsActions {\n  opacity: 1;\n}\n\n.editButton,\n.deleteButton {\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.editButton:hover {\n  background: #007bff;\n  color: white;\n}\n\n.deleteButton:hover {\n  background: #dc3545;\n  color: white;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  font-size: 18px;\n  color: #666;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 60px 20px;\n  color: #666;\n}\n\n.emptyState p {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .container {\n    padding: 15px;\n  }\n\n  .header {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n\n  .header h1 {\n    font-size: 2rem;\n  }\n\n  .newsGrid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .formContainer {\n    width: 95%;\n    padding: 20px;\n  }\n\n  .formActions {\n    flex-direction: column;\n  }\n}\n\n/* Стили для загрузки файлов */\n.imageUploadContainer {\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.fileInput {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.fileInputLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #f8f9fa;\n  border: 2px dashed #dee2e6;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-size: 14px;\n  color: #495057;\n}\n\n.fileInputLabel:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.imagePreview {\n  margin-top: 10px;\n  max-width: 200px;\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.imagePreview img {\n  width: 100%;\n  height: auto;\n  display: block;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewsManagement_container__OclcC`,
	"header": `NewsManagement_header__N+ozw`,
	"addButton": `NewsManagement_addButton__Lf0cd`,
	"limitWarning": `NewsManagement_limitWarning__6jKGa`,
	"formOverlay": `NewsManagement_formOverlay__54z3K`,
	"formContainer": `NewsManagement_formContainer__kl2fs`,
	"form": `NewsManagement_form__84t8Z`,
	"formGroup": `NewsManagement_formGroup__YWeso`,
	"formActions": `NewsManagement_formActions__uuKV2`,
	"saveButton": `NewsManagement_saveButton__tQymD`,
	"cancelButton": `NewsManagement_cancelButton__YSNbJ`,
	"newsGrid": `NewsManagement_newsGrid__Wkb5y`,
	"newsCard": `NewsManagement_newsCard__7g2ry`,
	"newsImage": `NewsManagement_newsImage__u0Ymv`,
	"newsContent": `NewsManagement_newsContent__NIe2E`,
	"newsMeta": `NewsManagement_newsMeta__rs2Qy`,
	"newsActions": `NewsManagement_newsActions__FQA9Y`,
	"editButton": `NewsManagement_editButton__P8E-D`,
	"deleteButton": `NewsManagement_deleteButton__4B1BQ`,
	"loading": `NewsManagement_loading__dMhNI`,
	"emptyState": `NewsManagement_emptyState__jdUs9`,
	"imageUploadContainer": `NewsManagement_imageUploadContainer__KoOFg`,
	"fileInput": `NewsManagement_fileInput__K1ql9`,
	"fileInputLabel": `NewsManagement_fileInputLabel__ozPV1`,
	"imagePreview": `NewsManagement_imagePreview__20PhP`
};
export default ___CSS_LOADER_EXPORT___;
